import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBubble3"><Path d="M12 2C6.47716 2 2.00001 6.47715 2.00001 12C2.00001 13.5557 2.35579 15.0303 2.99097 16.3451L2.01532 21.0992C1.96511 21.3439 2.04 21.5975 2.21508 21.7757C2.39015 21.9538 2.64243 22.0331 2.88795 21.9872L7.78535 21.0709C9.06697 21.6673 10.4956 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble3;
